import { TimeBasedRefundTableBean } from './TimeBasedRefundInteractiveTable.types';

export const addEmptyRow = (): TimeBasedRefundTableBean => ({ refundPercentage: null, thresholdInHours: null });
